import postLang from 'Menu/components/Lang/services/api/braincube';

export default postLang;
